import JSZip from "jszip";
import * as XLSX from 'xlsx';

export const getVerticesFromFile = async (zipFile: File) => {
    const inputZip = new JSZip();
    const topLvlZip = await inputZip.loadAsync(zipFile);
    const topLvlFiles = Object.keys(topLvlZip.files);
    const verticesFile = topLvlFiles.find((f) => f.includes("VERTICES_MAP"));
    if (!verticesFile) return "";
    if (verticesFile?.includes("csv")) return topLvlZip.file(verticesFile)!.async("string");
    else {
        const file = await topLvlZip
            .file(verticesFile)!
            .async("blob")
            .then((fileData) => {
                return new File([fileData], verticesFile);
            });
        return parseVerticesXlsx(file);
    }
};

const parseVerticesXlsx = async (file: File) => {
    return new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
            const wb = XLSX.read(e.target.result, { type: "binary" });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils
                .sheet_to_csv(ws)
                .split(" ")
                .join("")
                .split(',"')
                .join(";")
                .split('"')
                .join("");
            resolve(data);
        };
        reader.readAsBinaryString(file);
    });
};
